const cartButton = document.querySelector('.add_to_cart_sticky');
const productButton = document.querySelector('.payment-buttons');
const addButton = document.querySelector('.add_to_cart');
const addCartButton = document.querySelector('.add-to-cart');

addButton.addEventListener('click', function(){
  addCartButton.click();
});

const stickyButton = function(entries){
  const [entry] = entries;
if( window.pageYOffset > entry.boundingClientRect.y && !entry.isIntersecting ) cartButton.classList.add('add_to_cart_sticky--active');
else cartButton.classList.remove('add_to_cart_sticky--active');
}

const btnObserver = new IntersectionObserver ( stickyButton , {
  root: null,
  rootMargin: "0px",
  threshold: 1,
});

btnObserver.observe(productButton);